const defaultState = function () {
  return {
    mode: 0,
    tdLists: [],
    totalCount: 0,
    templateInfo: [],
    listIndex: -1,
    currentPage: 0,
    size: 10
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getDefaultState: defaultState
}



// WEBPACK FOOTER //
// ./src/store/pages/upload.js